<template>
	<JBox class="s-pb-64"><slot /></JBox>
</template>

<script>
export default {
	methods: {
		preventBrowserReload(event) {
			event.preventDefault()
			event.returnValue = "Are you sure you want to leave?" // Older browsers supported custom message
			return ""
		}
	},

	mounted() {
		window.addEventListener("beforeunload", this.preventBrowserReload)
	},

	beforeDestroy() {
		window.removeEventListener("beforeunload", this.preventBrowserReload)
	}
}
</script>
